document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('[data-test-form-root]');
  if (!containers.length) return;

  containers.forEach(function (container) {
    initTestForm(container);
  });

  function initTestForm(container) {
    var mount = container.querySelector('[data-test-form-mount]') || container;

    var appsScriptUrl = container.dataset.appsScriptUrl || '';
    var introLabel = container.dataset.introLabel || '';
    var quizLabel = container.dataset.quizLabel || '';
    var finalLabel = container.dataset.finalLabel || '';    

    var templateButton = container.querySelector('.test-form__button-template button');

    var buttonBaseClass = 'test-form__btn';
    var templateClass = templateButton ? templateButton.getAttribute('class') || '' : '';
    var templateStyle = templateButton ? templateButton.getAttribute('style') || '' : '';

    function createButton(label, options) {
      var opts = options || {};
      var btn = document.createElement('button');
      btn.type = opts.type || 'button';

      var cls = buttonBaseClass;
      if (templateClass) cls += ' ' + templateClass;
      btn.className = cls;

      if (templateStyle) {
        btn.setAttribute('style', templateStyle);
      }

      if (label && label.trim().length > 0) {
        btn.textContent = label;
      } else {
        // fallback if label is empty
        btn.textContent = opts.fallbackLabel || 'Continuar';
      }

      if (opts.dataRole) {
        btn.dataset.testFormRole = opts.dataRole;
      }

    btn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

      return btn;
    }

    var studentFirstName = '';
    var studentLastName = '';
    var studentWhatsapp = '';
    var currentQuizIndex = 0;
    var quizResults = [];
    var isSubmitting = false;

    var quizzes = [
      {
        id: 'A1',
        levelLabel: 'Principiante (A1)',
        title: 'Principiante (A1)',
        questions: [
          { id: 1, text: 'She ________ a teacher.', options: { a: 'is', b: 'are', c: 'am' }, correct: 'a' },
          { id: 2, text: 'I ________ to work every day.', options: { a: 'walks', b: 'walk', c: 'walkes' }, correct: 'b' },
          { id: 3, text: 'He is ________ right now.', options: { a: 'read', b: 'reading', c: 'reads' }, correct: 'b' },
          { id: 4, text: 'There ________ some milk in the fridge.', options: { a: 'are', b: 'is', c: 'have' }, correct: 'b' },
          { id: 5, text: 'What time is class?', options: { a: 'At Dawson', b: 'On 9:00 a.m.', c: 'At 9:00 a.m.' }, correct: 'c' },
          { id: 6, text: 'How old ________ you?', options: { a: 'have', b: 'are', c: 'do' }, correct: 'b' },
          { id: 7, text: 'How ________ students are in the class?', options: { a: 'any', b: 'much', c: 'many' }, correct: 'c' },
          { id: 8, text: 'I ________ meeting my friend soon.', options: { a: 'am', b: 'be', c: 'is' }, correct: 'a' },
          { id: 9, text: 'When is ________ birthday?', options: { a: 'her', b: 'she', c: 'hers' }, correct: 'a' },
          { id: 10, text: 'Tania ________ to the store yesterday.', options: { a: 'go', b: 'goes', c: 'went' }, correct: 'c' }
        ]
      },
      {
        id: 'A2',
        levelLabel: 'Básico (A2)',
        title: 'Básico (A2)',
        questions: [
          { id: 11, text: 'I’m sorry, I ________ go to a movie this weekend.', options: { a: 'can', b: 'can’t', c: 'do not' }, correct: 'b' },
          { id: 12, text: 'Canada is ________ France.', options: { a: 'bigger', b: 'bigger than', c: 'biggest' }, correct: 'b' },
          { id: 13, text: 'They ________ go to school at 8:30.', options: { a: 'has to', b: 'have to', c: 'can to' }, correct: 'b' },
          { id: 14, text: 'He ________ basketball on Tuesdays.', options: { a: 'plays', b: 'playing', c: 'is play' }, correct: 'a' },
          { id: 15, text: 'How ________ do you visit your parents?', options: { a: 'often', b: 'about', c: 'many time' }, correct: 'a' },
          { id: 16, text: 'It’s 9:00. Where’s Jim? He’s ________ here on time.', options: { a: 'sometimes', b: 'usual', c: 'usually' }, correct: 'c' },
          { id: 17, text: 'I love these jeans! I’m going to buy ________.', options: { a: 'they', b: 'me', c: 'them' }, correct: 'c' },
          { id: 18, text: 'Malcolm is busy. He ________ his homework right now.', options: { a: 'is doing', b: 'is do', c: 'doing' }, correct: 'a' },
          { id: 19, text: 'I bought cake because there ________ any pies.', options: { a: 'wasn’t', b: 'weren’t', c: 'is not' }, correct: 'b' },
          { id: 20, text: 'Susan ________ all day yesterday.', options: { a: 'work', b: 'works', c: 'worked' }, correct: 'c' }
        ]
      },
      {
        id: 'B1',
        levelLabel: 'Intermedio (B1)',
        title: 'Intermedio (B1)',
        questions: [
          { id: 21, text: 'I’ve already ________ to him this morning.', options: { a: 'speak', b: 'speaked', c: 'spoken' }, correct: 'c' },
          { id: 22, text: 'Can I have ________ sugar for my tea?', options: { a: 'any', b: 'some', c: 'much' }, correct: 'b' },
          { id: 23, text: 'Mary has lived in Calgary ________ 25 years.', options: { a: 'since', b: 'for', c: 'until' }, correct: 'b' },
          { id: 24, text: 'We ________ home when we saw the accident.', options: { a: 'were walking', b: 'are walking', c: 'is walking' }, correct: 'a' },
          { id: 25, text: 'They don’t have ________ brands of makeup.', options: { a: 'much', b: 'many', c: 'some' }, correct: 'b' },
          { id: 26, text: 'She ________ dinner when the lights ________.', options: { a: 'cooked / are going out', b: 'was cooking / went out', c: 'is cooking / go out' }, correct: 'b' },
          { id: 27, text: 'If ________, ________ the shuttle.', options: { a: 'you hurry / you’ll catch', b: 'you’ll hurry / you catch', c: 'you’ll hurry / you’ll catch' }, correct: 'a' },
          { id: 28, text: 'Would you rather stay in or go out tonight? Yes, ________ go out.', options: { a: 'I rather', b: 'I’d rather', c: 'I will rather' }, correct: 'b' },
          { id: 29, text: 'My son eats ________ ice cream.', options: { a: 'many', b: 'any', c: 'a lot of' }, correct: 'c' },
          { id: 30, text: 'They’re moving in two days! They ________ start packing.', options: { a: 'have better', b: 'had better', c: 'must to' }, correct: 'b' }
        ]
      },
      {
        id: 'B2',
        levelLabel: 'Intermedio avanzado (B2)',
        title: 'Intermedio avanzado (B2)',
        questions: [
          { id: 31, text: 'Doctors tell us to avoid ________ fatty foods.', options: { a: 'to eat', b: 'eating', c: 'eats' }, correct: 'b' },
          { id: 32, text: 'The metro system ________ in the late 60s.', options: { a: 'was build', b: 'was built', c: 'builded' }, correct: 'b' },
          { id: 33, text: 'My new apartment is ________ my old one. They’re the same size.', options: { a: 'as big as', b: 'bigger', c: 'as big' }, correct: 'a' },
          { id: 34, text: 'If I ________ more money, I would go on holiday.', options: { a: 'have', b: 'had', c: 'has' }, correct: 'b' },
          { id: 35, text: 'David and Maria ________ lots of exercise, but now they go swimming every day.', options: { a: 'didn’t use to get', b: 'used to get', c: 'got used to' }, correct: 'a' },
          { id: 36, text: 'Let’s go to a movie instead of ________ TV.', options: { a: 'to watch', b: 'watching', c: 'watch' }, correct: 'b' },
          { id: 37, text: 'The Mona Lisa ________ at the Louvre Museum since 1797.', options: { a: 'shown', b: 'has showed', c: 'has been shown' }, correct: 'c' },
          { id: 38, text: '________ this picture ________ last summer?', options: { a: 'Were / took', b: 'Was / taken', c: 'Was / took' }, correct: 'b' },
          { id: 39, text: '________ coat is that?', options: { a: 'Hers', b: 'Who’s', c: 'Whose' }, correct: 'c' },
          { id: 40, text: 'I ________ you what happened if I ________.', options: { a: 'would tell / knew', b: 'won’t / knew', c: 'would tell / know' }, correct: 'a' }
        ]
      },
      {
        id: 'C1',
        levelLabel: 'Avanzado (C1)',
        title: 'Avanzado (C1)',
        questions: [
          { id: 41, text: 'The kids are bored with ________ TV. Let’s go out.', options: { a: 'to watch', b: 'watching', c: 'watch' }, correct: 'b' },
          { id: 42, text: 'It’s a beautiful day, ________?', options: { a: 'is it', b: 'isn’t it', c: 'it is' }, correct: 'b' },
          { id: 43, text: 'Jane introduced her husband to her boss because they ________ before.', options: { a: 'had never met', b: 'has never met', c: 'had never meet' }, correct: 'a' },
          { id: 44, text: 'That’s the store where you can ________ your film ________ in an hour.', options: { a: 'get / develop', b: 'have / develop', c: 'get / developed' }, correct: 'c' },
          { id: 45, text: 'Mary ________ sick anymore if she’s gone back to work.', options: { a: 'must to feel', b: 'must feel', c: 'must not feel' }, correct: 'c' },
          { id: 46, text: 'I’ll have my assistant ________ your office at the end of the day.', options: { a: 'calling', b: 'call', c: 'to call' }, correct: 'b' },
          { id: 47, text: 'Kevin told me that he ________ for the airport at 6:30.', options: { a: 'was left', b: 'was leaving', c: 'was leave' }, correct: 'b' },
          { id: 48, text: 'Will your brother get someone ________ shopping for him?', options: { a: 'going', b: 'go', c: 'to go' }, correct: 'c' },
          { id: 49, text: 'Will this situation be extended until further notice? ________.', options: { a: 'I don’t think so', b: 'I don’t guess so', c: 'I don’t hope so' }, correct: 'a' },
          { id: 50, text: 'David said ________ careful if you go out during the snowstorm.', options: { a: 'be', b: 'don’t be', c: 'to be' }, correct: 'a' }
        ]
      }
    ];

    function renderIntro() {
      mount.innerHTML = '';

      var card = document.createElement('div');
      card.className = 'yk-card';

      card.innerHTML = `
        <h2 class="test-form__intro-title">Antes de empezar...</h2>

        <div class="test-form__fields">
          <div class="test-form__fields-row">
            <div class="field">
              <input
                id="yk-first-name"
                type="text"
                class="field__input"
                autocomplete="given-name"
                placeholder=" "
                required
              >
              <label class="field__label" for="yk-first-name">Nombre(s)</label>
            </div>

            <div class="field">
              <input
                id="yk-last-name"
                type="text"
                class="field__input"
                autocomplete="family-name"
                placeholder=" "
                required
              >
              <label class="field__label" for="yk-last-name">Apellido(s)</label>
            </div>
          </div>

        ${!localStorage.getItem('youknow_email') ? `
          <div class="field">
            <input
              id="yk-email"
              type="email"
              class="field__input"
              autocomplete="email"
              placeholder=" "
              required
            >
            <label class="field__label" for="yk-email">Email</label>
          </div>
        ` : ''}

          <div class="field">
            <input
              id="yk-whatsapp"
              type="tel"
              class="field__input"
              autocomplete="tel"
              placeholder=" "
              required
            >
            <label class="field__label" for="yk-whatsapp">WhatsApp</label>
          </div>
        </div>

        <div class="yk-status test-form__status" data-test-form-intro-status></div>
      `;

      var buttonLabel = introLabel || 'Empezar test';
      var startBtn = createButton(buttonLabel, {
        type: 'button',
        dataRole: 'intro',
        fallbackLabel: 'Empezar test'
      });

      startBtn.setAttribute('data-test-form-start', 'true');
      card.appendChild(startBtn);

      mount.appendChild(card);

      var statusEl = card.querySelector('[data-test-form-intro-status]');
      var firstnameInput = card.querySelector('#yk-first-name');
      var lastnameInput = card.querySelector('#yk-last-name');
      var whatsappInput = card.querySelector('#yk-whatsapp');
      var emailInput = card.querySelector('#yk-email');

      startBtn.addEventListener('click', function () {
        var firstVal = (firstnameInput.value || '').trim();
        var lastVal = (lastnameInput.value || '').trim();
        var waVal = (whatsappInput.value || '').trim();

        var emailVal = '';
        if (emailInput) {
          emailVal = (emailInput.value || '').trim();
        } else {
          emailVal = localStorage.getItem('youknow_email') || '';
        }        

        if (!firstVal || !lastVal || !waVal || (emailInput && !emailVal)) {
          statusEl.textContent = 'Por favor llena tus datos para continuar.';
          return;
        }

        // Save in memory (current behavior)
        studentFirstName = firstVal;
        studentLastName = lastVal;
        studentWhatsapp = waVal;

        // Persist for funnel continuity (NEW)
        try {
          localStorage.setItem('youknow_first_name', firstVal);
          localStorage.setItem('youknow_last_name', lastVal);
          localStorage.setItem('youknow_whatsapp', waVal);
        if (emailVal) {
          localStorage.setItem('youknow_email', emailVal);
        }
        } catch (e) {
          console.warn('LocalStorage unavailable', e);
        }

        currentQuizIndex = 0;
        quizResults = [];
        renderQuiz(quizzes[currentQuizIndex]);
      });
    }

    function renderQuiz(quiz) {
      mount.innerHTML = '';

      var card = document.createElement('div');
      card.className = 'yk-card';

      var progressPercent = Math.round(((currentQuizIndex + 1) / quizzes.length) * 100);

      var questionsHtml = quiz.questions
        .map(function (q, idx) {
          var optionsHtml = Object.keys(q.options)
            .map(function (key) {
              var optId = 'yk-q-' + quiz.id + '-' + q.id + '-' + key;
              return `
                <label for="${optId}">
                  <input type="radio" id="${optId}" name="q-${q.id}" value="${key}">
                  <span>${q.options[key]}</span>
                </label>
              `;
            })
            .join('');

          return `
            <div class="yk-question yk-question__question">
              <div>${idx + 1}. ${q.text}</div>
              <div class="yk-question__options">
                ${optionsHtml}
              </div>
            </div>
          `;
        })
        .join('');

      card.innerHTML = `
        <div class="yk-quiz__meta">
          <span class="yk-badge">${quiz.levelLabel}</span>
          <span>Parte ${currentQuizIndex + 1} de ${quizzes.length}</span>
        </div>
        <div class="yk-progress">
          <div class="yk-progress__bar" style="width:${progressPercent}%;"></div>
        </div>
        <h2 style="font-weight: bolder;">${quiz.title}</h2>
        <form data-test-form-quiz>
          ${questionsHtml}
          <div class="yk-status" data-test-form-quiz-status></div>
        </form>
      `;

      var buttonLabel = quizLabel || 'Continuar';
      var continueBtn = createButton(buttonLabel, {
        type: 'submit',
        dataRole: 'quiz',
        fallbackLabel: 'Continuar'
      });

      var form = card.querySelector('[data-test-form-quiz]');
      form.appendChild(continueBtn);

      mount.appendChild(card);

      var statusEl = card.querySelector('[data-test-form-quiz-status]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        statusEl.textContent = '';

        var score = 0;
        var total = quiz.questions.length;

        for (var i = 0; i < quiz.questions.length; i++) {
          var question = quiz.questions[i];
          var selected = form.querySelector('input[name="q-' + question.id + '"]:checked');
          if (!selected) {
            statusEl.textContent = 'Por favor responde todas las preguntas antes de continuar.';
            return;
          }
          if (selected.value === question.correct) {
            score++;
          }
        }

        handleQuizSubmit(quiz, score, total);
      });
    }

    function handleQuizSubmit(quiz, score, total) {
      quizResults.push({
        quizId: quiz.id,
        levelLabel: quiz.levelLabel,
        score: score,
        total: total
      });

      var passed = score / total >= 0.75;

      if (!passed) {
        finishTest(quiz.levelLabel);
      } else if (currentQuizIndex === quizzes.length - 1) {
        finishTest('C1 (Advanced)');
      } else {
        currentQuizIndex++;
        renderQuiz(quizzes[currentQuizIndex]);
      }
    }

    function formatDateMX(dateObj) {
      if (!(dateObj instanceof Date) || isNaN(dateObj)) return '';

      var day = dateObj.getDate();
      var month = dateObj.toLocaleDateString('es-MX', { month: 'long' });
      var year = dateObj.getFullYear();

      return `${day} de ${month} del ${year}`;
    }

    function getStartDateForLevel(level) {
      var config =
        window.youknowFunnelConfig ||
        (typeof rememberConfig !== 'undefined' ? rememberConfig : {}) ||
        {};
      var cohorts = config.cohorts || {};

      if (!cohorts[level] || !cohorts[level].startDate) return '';

      var dateObj = new Date(cohorts[level].startDate + 'T00:00:00');
      if (isNaN(dateObj.getTime())) return '';

      return formatDateMX(dateObj);
    }

    function finishTest(finalLevel) {
      mount.innerHTML = '';

      var card = document.createElement('div');
      card.className = 'yk-card';

      var friendlyLabel = finalLevel;
      var match = finalLevel.match(/\b(A1|A2|B1|B2|C1)\b/);
      var shortLevel = match ? match[1] : '';


      try {
        localStorage.setItem('youknow_level', shortLevel);
        localStorage.setItem('youknow_level_label', friendlyLabel);
        window.dispatchEvent(new Event('youknow:test:finished'));
      } catch (e) {
        console.warn('LocalStorage unavailable', e);
      }

      /* -----------------------------
        MATCH COPY BY LEVEL
      ----------------------------- */
      var matchCopyByLevel = {
        A1: {
          title: "Gracias, " + studentFirstName + ". Ahora es tu momento de aprender inglés.",
          body: function (){
            var date = getStartDateForLevel('A1');
            return `El próximo grupo empieza el <strong>${date}</strong>. Asegura tu lugar.`;
          } 
        },
        A2: {
          title: "Bien, " + studentFirstName + ". Tu inglés puede dar más.",
          body: function (){
            var date = getStartDateForLevel('A2');          
            return `El próximo grupo empieza el <strong>${date}</strong>. Asegura tu lugar.`;
          }
        },
        B1: {
          title: "Bien, " + studentFirstName + ". Entender ya no es suficiente, ahora toca hablarlo.",
          body: function (){
            var date = getStartDateForLevel('B1');           
            return `El próximo grupo empieza el <strong>${date}</strong>. Asegura tu lugar.`;
          }
        },
        B2: {
          title: "Excelente, " + studentFirstName + ". Tu inglés ya funciona, ahora hay que pulirlo.",
          body: function (){
            var date = getStartDateForLevel('B2');          
            return `El próximo grupo empieza el <strong>${date}</strong>. Asegura tu lugar.`;
          }
        },
        C1: {
          title: "Excelente, " + studentFirstName + ". Tu inglés ya es fuerte… ahora tiene que ser preciso.",
          body: function (){
            var date = getStartDateForLevel('C1');          
            return `El próximo grupo empieza el <strong>${date}</strong>. Asegura tu lugar.`;
          }
        }
      };

      var nonMatchCopyByLevel = {
        A1: {
          title: "Muy bien, " + studentFirstName + ". Este es tu punto de partida.",
          body: "Estamos por abrir el siguiente grupo A1. Únete a la lista de espera y te avisamos antes que nadie."
        },
        A2: {
          title: "Vas muy bien, " + studentFirstName + ". Ya tienes bases sólidas.",
          body: "Estamos por abrir el siguiente grupo A2. Únete a la lista de espera y te avisamos antes que nadie."
        },
        B1: {
          title: "Excelente, " + studentFirstName + ". Este es tu nivel ideal.",
          body: "Estamos por abrir el siguiente grupo B1. Únete a la lista de espera y te avisamos antes que nadie."
        },
        B2: {
          title: "Muy bien, " + studentFirstName + ". Este nivel es para ti.",
          body: "Estamos por abrir el siguiente grupo B2. Únete a la lista de espera y te avisamos antes que nadie."
        },
        C1: {
          title: "Excelente, " + studentFirstName + ". Estás en un nivel avanzado.",
          body: "Estamos por abrir el siguiente grupo C1. Únete a la lista de espera y te avisamos antes que nadie."
        }
      };      

      /* -----------------------------------------------------------------
        YOUKNOW FUNNEL LOGIC — dynamic routing based on metafields - START
      ------------------------------------------------------------------ */
/* -----------------------------------------------------------------
  YOUKNOW MULTI-COHORT LOGIC — dynamic routing based on metafields
------------------------------------------------------------------ */

var config = window.youknowFunnelConfig || {};
var cohorts = config.cohorts || {};
shortLevel = shortLevel.trim().toUpperCase();

var today = new Date();

// Track possible match
var matchedCohort = null;
var cohortIsActive = false;

// Loop through all cohorts A1–C1
Object.keys(cohorts).forEach(function (lvl) {
  var c = cohorts[lvl];
  if (!c) return;

  var url = c.product || "";
  var date = c.startDate || "";

  if (!url || !date) return; // skip empty cohorts

  var startDateObj = new Date(date + "T00:00:00");
  if (isNaN(startDateObj.getTime())) return;

  // Cohort is active only if start date is in the future
  var isActive = today < startDateObj;
  if (!isActive) return;

  cohortIsActive = true;

  // If user level matches this cohort → mark it as matched
  if (lvl.trim().toUpperCase() === shortLevel) {
    matchedCohort = {
      level: lvl,
      url: url,
      start: startDateObj
    };
  }
});

// Default outcome
var outcome = "fallback";
var cohortUrl = "";

// If at least one cohort is active:
if (cohortIsActive) {
  if (matchedCohort) {
    outcome = "match";          // user level matches an active cohort
    cohortUrl = matchedCohort.url;
  } else {
    // No match → need to decide lower vs higher
    // Lower-level logic (user too low)
    if (shortLevel === "A1" || shortLevel === "A2") {
      outcome = "lower";
    } else {
      outcome = "higher";
    }
  }
} else {
  // No active cohorts → full fallback
  outcome = "fallback";
}

/* Debug */
console.log("Multi-Cohort Outcome:", outcome, {
  shortLevel,
  matchedCohort,
  cohortIsActive
});    

      /* ---------------------------------------------------------------
        YOUKNOW FUNNEL LOGIC — dynamic routing based on metafields - END
      ---------------------------------------------------------------- */      

      // ✅ Now that matchedCohort is known, compute start date
      var startDateText = '';

      if (outcome === "match" && matchedCohort && matchedCohort.start) {
        startDateText = formatDateMX(matchedCohort.start);
      }

      var extraCopy = '';

        // MATCH → short, personal, conversion-focused
        if (outcome === "match" && matchCopyByLevel[shortLevel]) {
          var copy = matchCopyByLevel[shortLevel];

          extraCopy = `
            <strong>${copy.title}</strong><br>
            ${copy.body()}
          `;
        }         

        if (outcome !== "match" && nonMatchCopyByLevel[shortLevel]) {
          var copy = nonMatchCopyByLevel[shortLevel];

          extraCopy = `
            <strong>${copy.title}</strong><br>
            ${copy.body}
          `;
        }

      var resultButtonLabel = finalLabel || 'Ver opciones de grupos';    
      // Override CTA button text ONLY when level matches
      if (outcome === "match") {
        resultButtonLabel = "Continuar";
      }       

      card.innerHTML = `
        <h2 class="test-form__intro-title">Tu nivel estimado...</h2>
        <div class="yk-result__level">${friendlyLabel}</div>
        <p class="yk-result__extra">
          ${extraCopy}
        </p>
        <div class="yk-status" data-test-form-result-status></div>
      `;

      var ctaBtn = createButton(resultButtonLabel, {
        type: 'button',
        dataRole: 'result',
        fallbackLabel: 'Ver opciones de grupos'
      });
      ctaBtn.setAttribute('data-test-form-result-cta', 'true');

      card.appendChild(ctaBtn);
      mount.appendChild(card);

      if (typeof fbq === 'function') {
        try {
          var short = shortLevel; // A1, A2, B1, B2, C1

          // Generic lead (keep this)
          fbq('track', 'Lead', {
            testName: 'TestForm',
            level: short
          });

          // 🔥 Level-specific event
          fbq('trackCustom', 'Lead_' + short, {
            testName: 'TestForm',
            level: short
          });

        } catch (e) {
          console.warn('fbq error', e);
        }
      }

      if (appsScriptUrl && !isSubmitting) {
        isSubmitting = true;
        var payload = {
          firstName: studentFirstName,
          lastName: studentLastName,
          whatsapp: studentWhatsapp,
          email: localStorage.getItem('youknow_email') || '',
          finalLevel: finalLevel,
          quizzes: quizResults
        };

        fetch(appsScriptUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain'
          },
          body: JSON.stringify(payload)
        })
          .catch(function (err) {
            console.error('Error sending test data:', err);
          })
          .finally(function () {
            isSubmitting = false;
          });
      }

        var statusEl = card.querySelector('[data-test-form-result-status]');

        /* ORIGINAL ctaBTN

        ctaBtn.addEventListener('click', function () {
        // Si tenemos número y URL de WhatsApp, mandamos directo a WhatsApp
        if (waUrl) {
            window.open(waUrl, '_blank'); // o window.location.href = waUrl;
            return;
        }

        // Fallback: comportamiento anterior
        if (finalUrl && finalUrl !== '/') {
            window.location.href = finalUrl;
        } else {
            statusEl.textContent = 'Un miembro del equipo te contactará pronto con tus opciones.';
        }
        });

        */

        /* NEW ctaBTN - START */

        ctaBtn.addEventListener('click', function () {
          // MATCH → product page
          if (outcome === "match" && cohortUrl) {
            window.location.href = cohortUrl;
            return;
          }

          // NON-MATCH → waitlist (temporary)
          window.location.href = "/pages/waitlist";
        });

    }

    // Start
    renderIntro();
  }
});
